import { render, staticRenderFns } from "./OrderAddressDetails.vue?vue&type=template&id=75f57a87&scoped=true&"
import script from "./OrderAddressDetails.vue?vue&type=script&lang=js&"
export * from "./OrderAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddressDetails.vue?vue&type=style&index=0&id=75f57a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f57a87",
  null
  
)

export default component.exports